import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Location } from 'services/location.service'

@Component({
	selector: 'ras-nearby-suburbs',
	templateUrl: './nearby-suburbs.component.html',
	styleUrls: ['./nearby-suburbs.component.sass']
})
export class NearbySuburbsComponent implements OnInit {

	@Input() location: Location
	@ViewChild('inner') inner

	public show_all = false
	public height = "3.9em"

	private timer = null

	public toggle() {
		if (this.inner) {
			this.show_all = !this.show_all
			this.height = this.inner.nativeElement.getClientRects()[0].height + 'px'

			if (this.timer) clearTimeout(this.timer)
			this.timer = setTimeout(() => {
				this.height = this.show_all ? 'none' : '3.9em'
				this.timer = null
			}, 500)
		}
	}

	constructor() { }

	ngOnInit(): void {
	}

}
